<ng-container *transloco="let t; read:'permit.details.flammableAtexPermitModal'">
    <div class="modal">
        <div class="modal__content">
            <h2 class="modal__title">{{ t("title") }}</h2>

            <div class="root">
                <ng-container *ngIf="loading">
                    <div class="root__loading"></div>
                </ng-container>

                <ng-container *ngIf="!loading && hasError">
                    <div class="root__message">{{ t("error") }}</div>
                </ng-container>

                <ng-container *ngIf="isEmpty">
                    <div class="root__message">{{ t("empty") }}</div>
                </ng-container>

                <ng-container *ngIf="!loading && !hasError && questionnaire">
                    <div *ngIf="questionnaire.superintendentName || questionnaire.flammableAtexAdditionalInfo" class="root__section">
                        <div class="root__question">
                            <div class="root__question__content">
                                <div *ngIf="questionnaire.superintendentName" class="root__answer__text">
                                    <span class="root__answer__label">{{ t("superintendent") }}</span>
                                    <span>{{ questionnaire.superintendentName }}</span>
                                </div>
                                <div *ngIf="questionnaire.flammableAtexAdditionalInfo" class="root__answer__text">
                                    <span class="root__answer__label">{{ t("additionalInfo") }}</span>
                                    <span>{{ questionnaire.flammableAtexAdditionalInfo }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngFor="let section of questionnaire.sections" class="root__section">
                        <div class="root__section__heading">
                            <div class="root__section__heading__line"></div>
                            <div class="root__section__heading__text">{{ getSectionHeading(section) }}</div>
                            <div class="root__section__heading__line"></div>
                        </div>

                        <div class="root__questions">
                            <div *ngFor="let question of section.questions" class="root__question">
                                <div class="root__question__answer" [class]="'root__question__answer--' + getAnswerValue(question)"></div>
                                <div class="root__question__content">
                                    <div class="root__question__text" [innerHTML]="getQuestionTranslations(question)"></div>

                                    <ng-container *ngIf="hasAnswer(question)">
                                        <div *ngIf="getConditionText(question) as conditionText" class="root__answer__text">
                                            <ng-container *ngIf="shouldShowConditionLabel(question); else rawConditionText">
                                                <span class="root__answer__label">{{ t("condition") }}</span>
                                                <span>{{ conditionText }}</span>
                                            </ng-container>
                                            <ng-template #rawConditionText>
                                                <span>{{ conditionText }}</span>
                                            </ng-template>
                                        </div>

                                        <div *ngIf="getTextAnswer(question) as textAnswer" class="root__answer__text">
                                            {{ textAnswer }}
                                        </div>

                                        <div *ngIf="getNumberAnswer(question) !== null" class="root__answer__text">
                                            {{ getNumberAnswer(question) }}
                                        </div>

                                        <div *ngIf="getDateTimeAnswer(question) as dateTimeAnswer" class="root__answer__text">
                                            {{ formatDateTime(dateTimeAnswer) }}
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="modal__actions">
            <button class="modal__actions__close" type="button" (click)="closeModal()">{{ t("close") }}</button>
        </div>
    </div>
 </ng-container>
